import * as tslib_1 from "tslib";
import camelCaseToSnakeCase from '@core/utils/functions/camel-case-to-snake-case';
import { EnumPipe } from '@fuse/pipes/status/status.pipe';
import { TranslateService } from '@ngx-translate/core';
import { clone, isEqual } from 'lodash';
import moment from 'moment-timezone';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "../../../../../../../../@fuse/pipes/status/status.pipe";
var iconList = {
    pending: 'icon-calendar-clock',
    scheduled: 'icon-clock',
    inProgress: 'icon-map-marker',
    onRoute: 'icon-truck',
    reported: 'icon-alert',
    canceled: 'icon-close',
    done: 'icon-check'
};
var imageList = {
    archive: 'ic_archive_18px',
    unarchive: 'ic_unarchive_18px'
};
var CreateTaskLogsService = /** @class */ (function () {
    function CreateTaskLogsService(translateService, taskStatusPipe) {
        this.translateService = translateService;
        this.taskStatusPipe = taskStatusPipe;
    }
    CreateTaskLogsService.prototype.listTaskLogsMapped = function (tasks) {
        var _this = this;
        var logsMapped = [];
        tasks.forEach(function (task, taskIndex) {
            task.logs.forEach(function (currentTaskLog, logIndex) {
                var previousTaskLog = task.logs[logIndex - 1];
                var changedStatusLog = _this.generateStatusLog({
                    taskIndex: taskIndex,
                    currentTaskLog: currentTaskLog,
                    previousTaskLog: previousTaskLog
                });
                if (changedStatusLog) {
                    logsMapped.push(changedStatusLog);
                }
                var ratedLog = _this.generateRatingLog({ currentTaskLog: currentTaskLog, previousTaskLog: previousTaskLog, taskIndex: taskIndex });
                if (ratedLog) {
                    logsMapped.push(ratedLog);
                }
                var archivedLog = _this.generateArchiveOrUnarchiveLog({
                    currentTaskLog: currentTaskLog,
                    previousTaskLog: previousTaskLog,
                    taskIndex: taskIndex,
                });
                if (archivedLog) {
                    logsMapped.push(archivedLog);
                }
            });
        });
        return logsMapped;
    };
    CreateTaskLogsService.prototype.generateStatusLog = function (_a) {
        var currentTaskLog = _a.currentTaskLog, previousTaskLog = _a.previousTaskLog, taskIndex = _a.taskIndex;
        var previous = (previousTaskLog && previousTaskLog.snapshot && previousTaskLog.snapshot.status) || null;
        var current = (currentTaskLog.snapshot && currentTaskLog.snapshot.status) || null;
        if (previous === current) {
            return null;
        }
        var currentInSnakeCase = camelCaseToSnakeCase(String(currentTaskLog.snapshot && currentTaskLog.snapshot.status));
        var currentDescription = currentTaskLog.snapshot && currentTaskLog.snapshot.statusDescription;
        var eventNoteList = {
            reported: this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.REASON', {
                reason: currentDescription || this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.NOT_COMPLETED')
            }),
            canceled: this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.REASON', {
                reason: currentDescription || this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.NOT_COMPLETED')
            }),
            done: this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.CONCLUSION', {
                conclusion: currentDescription || this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.NOTE.NOT_COMPLETED')
            }),
        };
        if (!previous && current === 'scheduled') {
            currentTaskLog.eventDescription = this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.DESCRIPTION.NEW');
        }
        else if (!previous && current !== 'scheduled') {
            currentTaskLog.eventDescription = this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.DESCRIPTION.UPDATED_WITHOUT_PREVIOUS', {
                currentStatus: this.taskStatusPipe.transform(String(current), 'task_status').toLowerCase()
            });
        }
        else {
            currentTaskLog.eventDescription = this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.DESCRIPTION.UPDATED', {
                previousStatus: this.taskStatusPipe.transform(String(previous), 'task_status').toLowerCase(),
                currentStatus: this.taskStatusPipe.transform(String(current), 'task_status').toLowerCase()
            });
        }
        return tslib_1.__assign({}, clone(currentTaskLog), { icon: iconList[current], isCreatedLog: !previousTaskLog, typeLog: "task_" + currentTaskLog.snapshot.id, colorBackground: currentInSnakeCase + "--background", dateCreatedAt: moment(currentTaskLog.createdAt).local().format('DD/MM/YYYY'), dateTimeCreatedAt: moment(currentTaskLog.createdAt).local().format('DD/MM/YYYY HH:mm:ss'), eventNote: ['reported', 'canceled', 'done'].includes(current) && eventNoteList[current], eventName: this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.STATUS', {
                taskIndex: taskIndex + 1,
                class: currentInSnakeCase,
                status: this.taskStatusPipe.transform(String(current), 'task_status').toLowerCase()
            }) });
    };
    CreateTaskLogsService.prototype.generateRatingLog = function (_a) {
        var currentTaskLog = _a.currentTaskLog, previousTaskLog = _a.previousTaskLog, taskIndex = _a.taskIndex;
        var previousRating = (previousTaskLog && previousTaskLog.snapshot && previousTaskLog.snapshot.rating) || null;
        var currentRating = (currentTaskLog && currentTaskLog.snapshot && currentTaskLog.snapshot.rating) || null;
        if (isEqual(currentRating, previousRating)) {
            return null;
        }
        var starColor = 'positive-stars';
        if (currentTaskLog.snapshot.rating.stars === 3) {
            starColor = 'reasonable-stars';
        }
        else if (currentTaskLog.snapshot.rating.stars < 3) {
            starColor = 'negative-stars';
        }
        return tslib_1.__assign({}, clone(currentTaskLog), { icon: 'icon-star', isCreatedLog: false, isRateLog: true, typeLog: "task_" + currentTaskLog.snapshot.id, colorBackground: starColor + "--background", dateCreatedAt: moment(currentTaskLog.createdAt).local().format('DD/MM/YYYY'), dateTimeCreatedAt: moment(currentTaskLog.createdAt).local().format('DD/MM/YYYY HH:mm:ss'), eventDescription: currentTaskLog.snapshot.rating.comments || this.translateService.instant('MAINTENANCES.TABS.LOGS.TASK.DESCRIPTION.NO_COMMENTS'), eventName: this.translateService.instant("MAINTENANCES.TABS.LOGS.TASK.RATED", {
                taskIndex: taskIndex + 1
            }) });
    };
    CreateTaskLogsService.prototype.generateArchiveOrUnarchiveLog = function (_a) {
        var currentTaskLog = _a.currentTaskLog, previousTaskLog = _a.previousTaskLog, taskIndex = _a.taskIndex;
        var previousArchived = previousTaskLog && previousTaskLog.snapshot && previousTaskLog.snapshot.archived;
        var currentArchived = currentTaskLog.snapshot && currentTaskLog.snapshot.archived;
        if (!previousTaskLog || isEqual(currentArchived, previousArchived)) {
            return null;
        }
        var archived = currentArchived ? 'archive' : 'unarchive';
        return tslib_1.__assign({}, clone(currentTaskLog), { image: imageList[archived], isCreatedLog: false, typeLog: "task_" + currentTaskLog.snapshot.id, colorBackground: archived + "--background", dateCreatedAt: moment(currentTaskLog.createdAt).local().format('DD/MM/YYYY'), dateTimeCreatedAt: moment(currentTaskLog.createdAt).local().format('DD/MM/YYYY HH:mm:ss'), eventName: this.translateService.instant("MAINTENANCES.TABS.LOGS.TASK." + archived.toUpperCase(), {
                taskIndex: taskIndex + 1
            }) });
    };
    CreateTaskLogsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CreateTaskLogsService_Factory() { return new CreateTaskLogsService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.EnumPipe)); }, token: CreateTaskLogsService, providedIn: "root" });
    return CreateTaskLogsService;
}());
export { CreateTaskLogsService };
